/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:57e30362-34d9-4474-8817-7afa720f5cce",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_kcw5ft7bK",
    "aws_user_pools_web_client_id": "34v9p2lg0om65n07q0mdv8a0ch",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL",
        "PHONE_NUMBER"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://tgalh6tlqjg3dgizpqjhh4xla4.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "frouple96e9947e36934e19bf915eba7f25b1c5113431-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
